module.exports = __webpack_public_path__ + "img/logo.d747a875.svg";